import React from 'react';
import {Box, Typography} from '@material-ui/core';
import {PieLabelRenderProps} from 'recharts';

import {PieChart as EpicPieChart} from '@epic-visualizations/charts';
import useLocalization from '../../../../../../hooks/useLocalization';

const CODES = {
    description: 'epic.affiliate.fortnite_games.xp.sidebar.no_data'
};

interface RenderEmphasisProps extends PieLabelRenderProps {
    description: string;
}

const renderEmphasis = ({cx, cy, innerRadius, description}: RenderEmphasisProps) => {
    if (typeof cx !== 'number' || typeof cy !== 'number' || typeof innerRadius !== 'number') {
        return null;
    }

    return (
        <foreignObject
            x={cx - innerRadius}
            y={cy - innerRadius}
            width={innerRadius * 2}
            height={innerRadius * 2}
            style={{pointerEvents: 'none'}}>
            <Box
                width={innerRadius * 2}
                height="100%"
                display="flex"
                alignItems="center"
                justifyContent="center">
                <Typography align="center" variant="h5">
                    {description}
                </Typography>
            </Box>
        </foreignObject>
    );
};

const PieChart: typeof EpicPieChart = ({data = [], ...props}) => {
    const getMessage = useLocalization();
    const description = getMessage(CODES.description);

    const placeholderData = [{name: '', value: 1, color: '#232323'}];

    return data.length ? (
        <EpicPieChart hideLegend hideTooltip responsive data={data} {...props} />
    ) : (
        <EpicPieChart
            hideLegend
            hideTooltip
            responsive
            data={placeholderData}
            {...props}
            pieProps={{label: props => renderEmphasis({...props, description})}}
        />
    );
};

export default PieChart;
